import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=3528c957&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"
import style0 from "./MenuView.vue?vue&type=style&index=0&id=3528c957&prod&lang=less&scoped=true"
import style1 from "./MenuView.vue?vue&type=style&index=1&id=3528c957&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528c957",
  null
  
)

export default component.exports